export default __webpack_public_path__ + "static/media/mic-appointment-details.bd905843.svg";